import React from 'react';
import Nav from 'react-bootstrap/Nav';
import { useLocation, Link } from 'react-router-dom';
import './QualityTabs.scss';

const QualityTabs = () => {
  const location = useLocation();
  console.log("Current Path:", location.pathname);

  // Function to determine active tab based on path
  const getActiveKey = () => {
    if (location.pathname.startsWith('/quality/round')) return '/quality/round';
    if (location.pathname.startsWith('/quality/hog')) return '/quality/hog';
    if (location.pathname.startsWith('/quality/fillet')) return '/quality/fillet';
    if (location.pathname.startsWith('/quality/equipment')) return '/quality/equipment';
    return '/quality/fillet'; // Default active tab
  };

  return (
    <Nav variant="tabs" activeKey={getActiveKey()}>
      <Nav.Item>
        <Nav.Link   disabled= {true} as={Link} to="/quality/round" eventKey="/quality/round">Round</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link   disabled= {true} as={Link} to="/quality/hog" eventKey="/quality/hog">HOG</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link as={Link} to="/quality/fillet" eventKey="/quality/fillet">Fillet</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link   disabled= {true} as={Link} to="/quality/equipment" eventKey="/quality/equipment">Equipment</Nav.Link>
      </Nav.Item>
    </Nav>
  );
};

export default QualityTabs;
